import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { BriefApplicationResponseDto } from '@/app/common/general-types/briefs.dto';
import { CreatorActionPanel } from '../action-panel/action-panel';

@Component({
  selector: 'ins-creator-upload-instructions',
  imports: [CreatorActionPanel],
  templateUrl: './upload-instructions.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class CreatorUploadInstructions {
  application = input.required<BriefApplicationResponseDto>();
  readonly expanded = model(false);

  readonly shoutBrief = computed(() => this.application().brief?.shoutBrief);
}
